import React from 'react';

function Img(props) {
    const src = props.src;
    const propsCopy = {...props} ;
    delete propsCopy.src;

    return (
        <img {...props} src={`${process.env.PUBLIC_URL}/${src}`} ></img>
    )
}

export default Img;